import { getFullUrl } from 'hubspot-url-utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import Small from 'UIComponents/elements/Small';
import UILink from 'UIComponents/link/UILink';
import AutomatedMessageContent from '../../shared/components/AutomatedMessageContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function WorkflowGeneratedUserMessageSource({
  workflowName,
  flowId
}) {
  const workflowUrl = `${getFullUrl('app')}/workflows/${PortalIdParser.get()}/platform/flow/${flowId}`;
  return /*#__PURE__*/_jsxs(AutomatedMessageContent, {
    children: [/*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.workflow-generated-user-message.source-workflow"
      })
    }), /*#__PURE__*/_jsx(UILink, {
      href: workflowUrl,
      truncate: true,
      external: true,
      children: /*#__PURE__*/_jsx(Small, {
        children: workflowName || workflowUrl
      })
    })]
  });
}
WorkflowGeneratedUserMessageSource.displayName = 'WorkflowGeneratedUserMessageSource';